export enum ActivitiesListEditMode {
  Single = 'single',
  Multi = 'multi',
}
